import dayjs, { Dayjs } from "dayjs";
import { QuoteColumn } from "features/trading/accounts";

// The history table opens on the last 30 days, ending today.
export const DEFAULT_RANGE_DAYS = 30;

export const defaultRange = (today: Dayjs = dayjs()): [Dayjs, Dayjs] => [
  today.subtract(DEFAULT_RANGE_DAYS, "day").startOf("day"),
  today.startOf("day"),
];

/** The range as the quotes endpoint's `start_date`/`end_date` (YYYY-MM-DD). */
export const toRangeParams = ([start, end]: [Dayjs, Dayjs]) => ({
  start_date: start.format("YYYY-MM-DD"),
  end_date: end.format("YYYY-MM-DD"),
});

export const COLUMN_LABELS: Record<QuoteColumn, string> = {
  close: "Close",
  open: "Open",
  high: "High",
  low: "Low",
  volume: "Volume",
};

const PRICE_FORMAT = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
});

const VOLUME_FORMAT = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

/** A quote cell's text: "—" for a value the source did not report. */
export const formatQuoteValue = (
  column: QuoteColumn,
  value: number | null | undefined,
): string => {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) {
    return "—";
  }
  return column === "volume"
    ? VOLUME_FORMAT.format(Number(value))
    : PRICE_FORMAT.format(Number(value));
};

export const formatPrice = (value: number) => PRICE_FORMAT.format(value);
